import {
    BuroApp,
    getEnv,
} from 'b302-frontend-library';

import routes from './routing/Routes';
import nl from './lang/nl';

class FormDeskApp extends BuroApp {

    setup(): void {
        this.setupRequester(getEnv('REACT_APP_API_ENDPOINT'), []);
        this.setupRoutingConfig({ routes });
        this.setupTranslator({ nl });
    }
}

export default FormDeskApp;
